import { Observable } from 'rxjs';
import { EpicDeps } from '@wearejh/m2-pwa-engine/lib/types';
import { ofType } from 'redux-observable';
import { filter, mapTo, pluck, withLatestFrom, map } from 'rxjs/operators';

import { AppendState } from '../cart.reducer';
import { CartMsg } from '../cart.actions';

export function clearMessages(
    action$: Observable<any>,
    state$: Observable<AppendState>,
    deps: EpicDeps,
): Observable<any> {
    const msgCount$ = state$.pipe(
        pluck('cart'),
        map((cart) => cart.messages.length + Object.keys(cart.itemMessages).length),
    );
    return action$.pipe(
        ofType(deps.LOCATION_CHANGE),
        withLatestFrom(msgCount$),
        filter(([, msgCount]) => msgCount > 0),
        mapTo(CartMsg('Cart.ClearAllItemMessages')),
    );
}
